import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import * as styles from './styles'
import { getOptionLabel, getOptionValue } from './helpers'

const EditBeneficiaryFormComponent = ({
  form,
  header,
  loadJurisdictions,
  loadCategories,
  loadSubcategories,
  onSubmitRequest,
  initialValues,
}) => (
  <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
    {(editable) => {
      const disabled = !editable
      const isEdit = !!initialValues
      return (
        <>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Name
            </Text>
            <FormInput
              strictLong
              name="beneficiaryName"
              placeholder="Name"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              E-mail
            </Text>
            <FormInput
              autoComplete="off"
              strictLong
              name="email"
              placeholder="Email"
              css={styles.control}
              disabled={!editable || isEdit}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Country
            </Text>
            <FormInput
              oldInput
              strictLong
              cacheOptions
              defaultOptions
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="country"
              placeholder="Select country"
              loadOptions={loadJurisdictions}
              styles={styles.select}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Jurisdiction
            </Text>
            <FormInput
              oldInput
              strictLong
              cacheOptions
              defaultOptions
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="jurisdiction"
              placeholder="Jurisdiction"
              loadOptions={loadJurisdictions}
              styles={styles.select}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Categories
            </Text>
            <FormInput
              oldInput
              isMulti
              strictLong
              cacheOptions
              defaultOptions
              isSearchable={false}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="categories"
              placeholder="Categories"
              loadOptions={loadCategories}
              styles={styles.select}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Subcategories
            </Text>
            <FormInput
              oldInput
              isMulti
              strictLong
              cacheOptions
              defaultOptions
              isSearchable={false}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="subCategories"
              placeholder="Subcategories"
              loadOptions={loadSubcategories}
              styles={styles.select}
              disabled={disabled}
            />
          </Margin>
          {!initialValues?.id && (
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={11}>
                Password
              </Text>
              <FormInput
                autoComplete="new-password"
                strictLong
                type="password"
                name="password"
                placeholder="Password"
                css={styles.control}
                disabled={disabled}
              />
            </Margin>
          )}

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Website
            </Text>
            <FormInput
              strictLong
              name="website"
              placeholder="Website"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Logo
            </Text>
            <FormInput
              strictLong
              name="logo"
              placeholder="Put link to logo here"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.rowWithToggle}>
            <Text as="label" size={11}>
              Member status
            </Text>
            <FormInput
              oldInput
              name="active"
              type="toggle"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
          <Margin bottom={1} css={styles.rowWithToggle}>
            <Text as="label" size={11}>
              Marketing Promotion
            </Text>
            <FormInput
              oldInput
              name="marketingPromotion"
              type="toggle"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>
        </>
      )
    }}
  </EditableFormPanel>
)

EditBeneficiaryFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  loadJurisdictions: PropTypes.func,
  loadCategories: PropTypes.func,
  loadSubcategories: PropTypes.func,
  onSubmitRequest: PropTypes.func,
  initialValues: PropTypes.shape(),
}

export default EditBeneficiaryFormComponent
